import { Error403Unauthorized } from '@app/components';
import {
  DeleteProductsModal,
  EditProductGroupSalePriceModal,
} from '@app/components/Modals';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { PF } from '@app/pages/Warehouses/Products/data';
import {
  useProducts,
  useProductsEffects,
} from '@app/pages/Warehouses/Products/hooks';
import { Filters } from '@app/pages/Warehouses/Products/ui/Filters';
import { ProductsTable } from '@app/pages/Warehouses/Products/ui/ProductsTable';
import { FiltersAccordion } from '@app/shared/components';

import type { FC } from 'react';

import '@pages/Warehouses/Products/styles/Products.scss';

export const Products: FC = () => {
  const {
    onFilterChange,
    isPageLoading,
    isFetching,
    onChangeSearchTerm,
    tableData,
    skipFilters,
    onSearch,
    onPageSizeChange,
    onPaginate,
    pagination,
    unsavedFilters,
    onSearchHandler,
    columns,
    disabledFilters,
    categoryOptions,
    brandsOptions,
    warehousesOptions,
    filtersListsHandler,
    syncWarehouseIdSearchParam,
    isPageForbidden,
    onCloseDeleteModal,
    isOpenDeleteModal,
    deleteModalData,
    onSaveFiltersToStorage,
    isOpenEditSalePriceModal,
    editSalePriceData,
    onCloseEditSalePriceModal,
  } = useProducts();

  useProductsEffects({
    onSearchHandler,
    filtersListsHandler,
    onSaveFiltersToStorage,
    syncWarehouseIdSearchParam,
  });

  if (isPageForbidden) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <div className={`${PF}_container`}>
      <div className={`${PF}_filters-section`}>
        <FiltersAccordion>
          <Filters
            unsavedFilters={unsavedFilters}
            onChange={onFilterChange}
            onChangeSearchTerm={onChangeSearchTerm}
            skipFilters={skipFilters}
            onSearch={onSearch}
            disabled={disabledFilters}
            categoryOptions={categoryOptions}
            brandsOptions={brandsOptions}
            warehousesOptions={warehousesOptions}
          />
        </FiltersAccordion>
      </div>

      <div className={`${PF}_table-section`}>
        <ProductsTable
          columns={columns}
          isPageLoading={isPageLoading}
          isFetching={isFetching}
          onPaginate={onPaginate}
          onPageSizeChange={onPageSizeChange}
          data={tableData}
          pagination={pagination}
        />
      </div>

      {!!deleteModalData && (
        <DeleteProductsModal
          open={isOpenDeleteModal}
          onClose={onCloseDeleteModal}
          afterDelete={onSearchHandler}
          {...deleteModalData}
        />
      )}

      {!!editSalePriceData && (
        <EditProductGroupSalePriceModal
          open={isOpenEditSalePriceModal}
          productId={editSalePriceData.ProductId}
          warehouseId={editSalePriceData.WarehouseId}
          productName={editSalePriceData.Name}
          warehouseName={editSalePriceData.Warehouse}
          currentMinSalePrice={editSalePriceData.PriceOfSaleS}
          currentMaxSalePrice={editSalePriceData.PriceOfSaleE}
          onClose={onCloseEditSalePriceModal}
          afterSave={onSearchHandler}
        />
      )}
    </div>
  );
};
